import { normalizeRoleCode, resolveUserRoleName } from "../constants";

/** Roles excluded from coverage area + availability (matches backend SRVY exclude). */
export const ROLES_WITHOUT_COVERAGE_ACCESS = new Set(["SRVY"]);

/** Accepts a role name string or a user/session object. */
const toRoleName = (roleOrUser) => {
  if (!roleOrUser) return "";
  if (typeof roleOrUser === "string") return roleOrUser;
  if (roleOrUser.role?.name) return roleOrUser.role.name;
  return resolveUserRoleName(roleOrUser);
};

export const canUserAccessCoverageFeatures = (roleOrUser) => {
  const code = normalizeRoleCode(toRoleName(roleOrUser));
  return Boolean(code) && !ROLES_WITHOUT_COVERAGE_ACCESS.has(code);
};

/** List page row actions — only for users who can use coverage/availability. */
export const canManageRowCoverageActions = (userRow) =>
  canUserAccessCoverageFeatures(userRow?.role?.name ?? userRow);

/** Admin/OA may edit other users from the Coverage Area list. */
export const canEditOthersFromCoverageList = (sessionUser) => {
  const code = normalizeRoleCode(toRoleName(sessionUser));
  return code === "ADMIN" || code === "OA";
};
